import { postContractSearch, } from '@zurich/api/search';
import { useIndexSearch } from './useIndexSearch';
export function useContractSearch(options) {
    return useIndexSearch({
        request: postContractSearch,
        suggestions: options?.suggestions,
    });
}
